<template>
  <div class="hover-component">
    <div
      class="content"
      @mouseenter="showImage = true"
      @mouseleave="showImage = false"
    >
      <slot></slot>
    </div>
    <div
      class="image-container"
      v-show="showImage"
      :class="{ show: showImage }"
    >
      <slot name="image"></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showImage: false,
    };
  },
  methods: {
    hide() {
      this.showImage = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.hover-component {
  display: flex;
  position: relative;
  align-items: center;
}

.content {
  flex: 1;
}

.image-container {
  position: absolute;
  bottom: 0;
  right: 100%;
  opacity: 0;
  transition: opacity 0.3s;
}

.image-container.show {
  opacity: 1;
}

.image-container img {
  width: 100%;
  height: auto;
}
</style>
